<template>
  <div id="app">
    <!-- <sidebar></sidebar> -->
    <router-view v-if="isRouterAlive"/>
  </div>
</template>
<script>
export default {
  data(){
    return{
      isRouterAlive:true
    }
  },
  provide(){
    return{
      reload:this.reload
    }
  },
  methods:{
    reload(){
      this.isRouterAlive=false
      this.$nextTick(function(){
        this.isRouterAlive=true
      })
    }
  },
}
</script>
<style>
*{margin: 0;padding: 0;}
/* 定义iconfont */

@font-face {
  font-family: 'iconfont';  /* Project id 3203304 */
  src: url('//at.alicdn.com/t/font_3203304_j06lm67t8r.woff2?t=1652340310107') format('woff2'),
       url('//at.alicdn.com/t/font_3203304_j06lm67t8r.woff?t=1652340310107') format('woff'),
       url('//at.alicdn.com/t/font_3203304_j06lm67t8r.ttf?t=1652340310107') format('truetype'),
       url('//at.alicdn.com/t/font_3203304_j06lm67t8r.svg?t=1652340310107#iconfont') format('svg');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

</style>
